"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reorderSteps = reorderSteps;
const dist_1 = require("../../fs/dist");
async function reorderSteps(input, deps) {
    const weaveId = await (0, dist_1.resolveWeaveSlugForPlan)(deps.loomRoot, input.planUlid);
    const weave = await deps.loadWeave(deps.loomRoot, weaveId);
    const plan = weave.threads.flatMap((t) => t.plans).find((p) => p.id === input.planUlid);
    if (!plan) {
        throw new Error(`Plan '${input.planUlid}' not found in weave '${weaveId}'`);
    }
    await deps.runEvent(weaveId, { type: 'REORDER_STEPS', planId: input.planUlid, orderedStepIds: input.orderedStepIds });
    const updatedWeave = await deps.loadWeave(deps.loomRoot, weaveId);
    const updatedPlan = updatedWeave.threads.flatMap((t) => t.plans).find((p) => p.id === input.planUlid);
    return { plan: updatedPlan };
}
